import HUB_MESSAGING_UTILS from '@/store/actions/hubActions/hubMessagingUtils.js'
import HUB_MESSAGING_SIMPLE from '@/store/actions/hubActions/hubMessagingSimple.js'
import HUB_MESSAGING_COMPLEX from '@/store/actions/hubActions/hubMessagingComplex.js'
import HUB_CONNECTION_ACTIONS from '@/store/actions/hubActions/hubConnectionActions.js'

const HUB_ACTIONS = {
  ...HUB_MESSAGING_UTILS,
  ...HUB_MESSAGING_SIMPLE,
  ...HUB_MESSAGING_COMPLEX,
  ...HUB_CONNECTION_ACTIONS,
}
export default HUB_ACTIONS;